import React from 'react'
import { connect } from 'react-redux'
import { toggleGeneratePdf, togglePdfLoading } from '../../modules/reducer'

import { BlobProvider } from '@react-pdf/renderer'

import { savePdf } from '../drupal'

export const MyPdfDownloadLink = ({
  document: doc,
  mail,
  idUsuario,
  idEnlace,
  idProyecto,
  idioma,
  toggleGeneratePdf,
  generatePdf,
  togglePdfLoading
}) => {
  if (!doc) {
    console.log('You should pass a valid document to PDFDownloadLink')
    return null
  }

  return generatePdf ? (
    <BlobProvider document={doc}>
      {({ blob, url, loading, error }) => {
        if (!loading) {
          savePdf({
            blobPdf: blob,
            resolveD: url => {
              const enlace = document.getElementById(idEnlace)
              enlace.href = url
              enlace.click()
              toggleGeneratePdf()
              togglePdfLoading()
            },
            resolveM: url => {
              toggleGeneratePdf()
              togglePdfLoading()
            },
            mail,
            idUsuario,
            idProyecto,
            idioma
          })
        }
        return null
      }}
    </BlobProvider>
  ) : null
}

const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    generatePdf: reducer.generatePdf,
    idProyecto: reducer.idProyecto,
    idioma: reducer.idioma
  }
}

const mapDispatchToProps = {
  toggleGeneratePdf,
  togglePdfLoading
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyPdfDownloadLink)
